export const state = () => (require('@pleinair/bigcolony-vue/store/catering/_state')())
export const mutations = require('@pleinair/bigcolony-vue/store/catering/_mutations')
export const actions = require('@pleinair/bigcolony-vue/store/catering/_actions')